import { GeneralService } from "../../../../../services/GeneralService";
import { CurrentLocation } from "../../components/CurrentLocation";
import { order } from "../SmartSearchParammeter";

export default async function CurrentLocationSearchConfig(key) {
  let country = await GeneralService.getCountries();
  
  return {
    description: "Current Location",
    id: "countryId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <CurrentLocation searchObject={searchObject} setSearchObject={setSearchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact"],
    list: country.map((m) => m.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
        searchObj["countryId"] = country
          .filter((m) => value[0] === m.description.replace(/#/g, ",").trim())
          .map((m) => m.id)
          .shift();
    }
  };
}